(function($) {

  $(document).ready(function() {
    $('.flexible--carrousel .owl-carousel').owlCarousel({
      loop: true,
      items: 1,
      nav: true,
      navElement: 'button',
      dots: true,
      margin: 0,
    });
  });

})(jQuery);
